import { ContentType, errors, ErrorType } from '../content';

export const getAlertFromKey = ({
  contentType,
  errorKey,
  jobId,
}: {
  contentType: ContentType;
  errorKey?: ErrorType;
  jobId?: string;
}) => {
  if (!errors[contentType]) return errors.seCe(jobId).DEFAULT;
  if (!errorKey) return errors[contentType](jobId).DEFAULT;
  if (errors[contentType](jobId)[errorKey]) return errors[contentType](jobId)[errorKey];
  return errors[contentType](jobId).DEFAULT;
};
